import { apiClient } from './apiClient';
import type { BookProcessingStatusDto } from '../types/manageBooks';

/**
 * Backend returns ABP's paged list envelope:
 *   { items: BookProcessingStatusDto[], totalCount: number }
 */
interface ListResult {
  items: BookProcessingStatusDto[];
  totalCount: number;
}

const BASE = '/api/app/book-processing-statuses';

export const bookProcessingStatusService = {
  /**
   * List all processing-status rows for a single book. Used by the polling
   * hook on the Manage Books page to drive the "Indexing…" pill.
   *
   * Filtering by bookId goes through ABP's standard GetListInput. We also cap
   * maxResultCount — no single book is expected to have more than a handful
   * of concurrent jobs, but the safeguard avoids an unbounded fetch if the
   * row count ever grows.
   */
  listByBookId: async (bookId: string): Promise<BookProcessingStatusDto[]> => {
    const { data } = await apiClient.get<ListResult>(BASE, {
      params: {
        bookId,
        skipCount: 0,
        maxResultCount: 50,
        sorting: 'bookProcessingStatus.creationTime desc',
      },
    });
    return data.items;
  },
};
